import { configureStore } from "@reduxjs/toolkit";

import { activityApi } from "./api/activityQuery";
import { adminApi } from "./api/adminQuery";
import { authApi } from "./api/authQuery";
import { calendarApi } from "./api/calendarQuery";
import { claimsApi } from "./api/claimsQuery";
import { clientApi } from "./api/clientQuery";
import { C_WareHouseAPI } from "./api/customer-portal/C_WareHouseQuery";
import { WasteManagementApi } from "./api/customer-portal/C_WasteManagementQuery";
import { C_DashboardApi } from "./api/customer-portal/Dashboard.Query";
import { customerGeneralApi } from "./api/customer-portal/GeneralQuery";
import { C_InvoiceApi } from "./api/customer-portal/InvoiceQuery";
import { C_ProjectApi } from "./api/customer-portal/Project.Query";
import { UserManagementApi } from "./api/customer-portal/UserManageQuery";
import { C_DocketApi } from "./api/customer-portal/docket.query";
import { C_SupportApi } from "./api/customer-portal/support.query";
import { docketApi } from "./api/docketQuery";
import { documentParserApi } from "./api/documentParserApi";
import { employeeApi } from "./api/employeeQuery";
import { rtkQueryErrorLogger } from "./api/error";
import { fleetAPi } from "./api/fleetQuery";
import { generalApi } from "./api/generalQuery";
import { invoicingApi } from "./api/invoicingQuery";
import { itemsApi } from "./api/itemQuery";
import { managerApi } from "./api/managerQuery";
import { messageApi } from "./api/messageQuery";
import { payrollApi } from "./api/payrollQuery";
import { prApi } from "./api/prQuery";
import { projectApi } from "./api/projectsQuery";
import { reportsApi } from "./api/reportsQuery";
import { rosterApi } from "./api/rosterQuery";
import { subContractorApi } from "./api/subContractorQuery";
import { supportApi } from "./api/supportQuery";
import { timeTrackingApi } from "./api/timeTrackingSettingQuery";
import { userTimetrackingApi } from "./api/timeTrackingUsersQuery";
import { toolsApi } from "./api/toolsQuery";
import { userApi } from "./api/userQuery";
import { wareHousingApi } from "./api/wareHousingQuery";
import { wasteManagementApi } from "./api/wasteManageSummaryandSettings";
import { wasteManagementTypeApi } from "./api/wasteManagementTypeQuery";
import { weighBridgeApi } from "./api/weighBridgeQuery";
import { weighScaleApi } from "./api/weighScaleQuery";
import { workforceSettingsApi } from "./api/workforceSettingsQuery";
import { workspaceApi } from "./api/workspaceQuery";
import { xeroApi } from "./api/xeroQuery";
import AlertSlice from "./slices/AlertSlice";
import configSlice from "./slices/configSlice";
import featureFlagSlice from "./slices/featureFlagSlice";
import notificationSlice from "./slices/notificationSlice";
import permissionSlice from "./slices/permissionSlice";
import userSlice from "./slices/userSlice";

export const store = configureStore({
  reducer: {
    config: configSlice,
    user: userSlice,
    alert: AlertSlice,
    notification: notificationSlice,
    permissions: permissionSlice,
    feature: featureFlagSlice,
    [authApi.reducerPath]: authApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [workspaceApi.reducerPath]: workspaceApi.reducer,
    [generalApi.reducerPath]: generalApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [subContractorApi.reducerPath]: subContractorApi.reducer,
    [managerApi.reducerPath]: managerApi.reducer,
    [clientApi.reducerPath]: clientApi.reducer,
    [wasteManagementApi.reducerPath]: wasteManagementApi.reducer,
    [projectApi.reducerPath]: projectApi.reducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
    [employeeApi.reducerPath]: employeeApi.reducer,
    [timeTrackingApi.reducerPath]: timeTrackingApi.reducer,
    [payrollApi.reducerPath]: payrollApi.reducer,
    [itemsApi.reducerPath]: itemsApi.reducer,
    [prApi.reducerPath]: prApi.reducer,
    [claimsApi.reducerPath]: claimsApi.reducer,
    [fleetAPi.reducerPath]: fleetAPi.reducer,
    [docketApi.reducerPath]: docketApi.reducer,
    [rosterApi.reducerPath]: rosterApi.reducer,
    [documentParserApi.reducerPath]: documentParserApi.reducer,
    [xeroApi.reducerPath]: xeroApi.reducer,
    [invoicingApi.reducerPath]: invoicingApi.reducer,
    [wareHousingApi.reducerPath]: wareHousingApi.reducer,
    [customerGeneralApi.reducerPath]: customerGeneralApi.reducer,
    [UserManagementApi.reducerPath]: UserManagementApi.reducer,
    [C_ProjectApi.reducerPath]: C_ProjectApi.reducer,
    [C_InvoiceApi.reducerPath]: C_InvoiceApi.reducer,
    [calendarApi.reducerPath]: calendarApi.reducer,
    [WasteManagementApi.reducerPath]: WasteManagementApi.reducer,
    [wasteManagementTypeApi.reducerPath]: wasteManagementTypeApi.reducer,
    [C_WareHouseAPI.reducerPath]: C_WareHouseAPI.reducer,
    [C_DashboardApi.reducerPath]: C_DashboardApi.reducer,
    [C_DocketApi.reducerPath]: C_DocketApi.reducer,
    [C_SupportApi.reducerPath]: C_SupportApi.reducer,
    [supportApi.reducerPath]: supportApi.reducer,
    [messageApi.reducerPath]: messageApi.reducer,
    [activityApi.reducerPath]: activityApi.reducer,
    [userTimetrackingApi.reducerPath]: userTimetrackingApi.reducer,
    [workforceSettingsApi.reducerPath]: workforceSettingsApi.reducer,
    [weighBridgeApi.reducerPath]: weighBridgeApi.reducer,
    [weighScaleApi.reducerPath]: weighScaleApi.reducer,
    [toolsApi.reducerPath]: toolsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      // error logger
      rtkQueryErrorLogger,

      authApi.middleware,
      adminApi.middleware,
      clientApi.middleware,
      workspaceApi.middleware,
      generalApi.middleware,
      userApi.middleware,
      subContractorApi.middleware,
      managerApi.middleware,
      wasteManagementApi.middleware,
      wasteManagementTypeApi.middleware,
      projectApi.middleware,
      reportsApi.middleware,
      claimsApi.middleware,
      employeeApi.middleware,
      timeTrackingApi.middleware,
      payrollApi.middleware,
      itemsApi.middleware,
      prApi.middleware,
      docketApi.middleware,
      fleetAPi.middleware,
      rosterApi.middleware,
      documentParserApi.middleware,
      xeroApi.middleware,
      invoicingApi.middleware,
      customerGeneralApi.middleware,
      UserManagementApi.middleware,
      C_ProjectApi.middleware,
      C_InvoiceApi.middleware,
      calendarApi.middleware,
      WasteManagementApi.middleware,
      wareHousingApi.middleware,
      C_WareHouseAPI.middleware,
      C_DashboardApi.middleware,
      C_DocketApi.middleware,
      C_SupportApi.middleware,
      supportApi.middleware,
      messageApi.middleware,
      activityApi.middleware,
      userTimetrackingApi.middleware,
      workforceSettingsApi.middleware,
      weighBridgeApi.middleware,
      weighScaleApi.middleware,
      toolsApi.middleware,
    ),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
